import { NgModule } from '@angular/core';
import { CommonModule, APP_BASE_HREF } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';

// Shared modules
import { CoreModule } from '../core';
import { SharedModule } from '../shared';

// UI Module
import { UIModule } from '../ui.module';

// Module's pages components.
import { MarketRouting } from './market.routing';
import { BaseComponent } from './base/base.component';
import { AllOrdersComponent } from './all-orders/all-orders.component';
import { MyOrdersComponent } from './my-orders/my-orders.component';
import { HistoryComponent } from './history/history.component';
import { SubscriptionTokenComponent } from './subscription-token/subscription-token.component';
import { ShardSelectorComponent } from './shard-selector/shard-selector.component';
import { ResourceComponent } from './resource/resource.component';
import { ResourceNamePipe } from './resource-name.pipe';
import { DlgResourceOrdersComponent } from './dlg-resource-orders/dlg-resource-orders.component';
import { TableOrdersComponent } from './table-orders/table-orders.component';
import { TablePriceHistoryComponent } from './table-price-history/table-price-history.component';
import { TableMyOrdersComponent } from './table-my-orders/table-my-orders.component';
import { TableHistoryComponent } from './table-history/table-history.component';
import { RefreshComponent } from './refresh/refresh.component';
import { TransactionDetailsComponent } from './transaction-details.component';
import { ShowResourceOrdersDirective } from './show-resource-orders.directive';
import { RoomRangePipe } from './room-range.pipe';
import { AllOrdersResolves } from './all-orders/all-orders.resolver';
import { MyOrdersResolver } from './my-orders/my-orders.resolver';
import { HistoryResolver } from './history/history.resolver';
import { ResourceOrdersComponent } from './resource-orders/resource-orders.component';
import { ResourceOrdersResolver } from './resource-orders/resource-orders.resolver';
import { ToggleComponent } from './toggle/toggle.component';
import { TransactionUserAtRoomComponent } from './transaction-user-at-room.component';
import { TransactionResourceComponent } from './transaction-resource.component';
import { ResourcePriceComponent } from './resource-price.component';

import { ResourceUnlockComponent } from './resource-unlock.component';
import { ResourcePixelsComponent } from './resource-pixels.component';
import { ResourceKeysComponent } from './resource-keys.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MatSortModule,
        MatTableModule,
        MatSelectModule,
        FormsModule,
        BrowserAnimationsModule,

        CoreModule,
        SharedModule,
        UIModule,

        MarketRouting
    ],
    exports: [
        RouterModule
    ],
    declarations: [
        // Section Components
        BaseComponent,
        AllOrdersComponent,
        MyOrdersComponent,
        HistoryComponent,
        SubscriptionTokenComponent,
        ShardSelectorComponent,
        ResourceComponent,
        ResourceNamePipe,
        DlgResourceOrdersComponent,
        TableOrdersComponent,
        TablePriceHistoryComponent,
        TableMyOrdersComponent,
        TableHistoryComponent,
        RefreshComponent,
        TransactionDetailsComponent,
        ShowResourceOrdersDirective,
        RoomRangePipe,
        ResourceOrdersComponent,
        ToggleComponent,
        TransactionUserAtRoomComponent,
        TransactionResourceComponent,
        ResourcePriceComponent,

        ResourceUnlockComponent,
        ResourcePixelsComponent,
        ResourceKeysComponent,
    ],
    entryComponents: [
        BaseComponent,
        DlgResourceOrdersComponent
    ],
    providers: [
        HistoryResolver,
        MyOrdersResolver,
        AllOrdersResolves,
        ResourceOrdersResolver
    ]
})
export class MarketModule { }
